// Images
import Movie1 from '../images/movie1.jpg';
import Movie2 from '../images/movie2.jpg';
import MovieIconEuronics from '../images/movie-yellow.png';
import MovieIconDatart from '../images/movie-orange.png';

import Nature1 from '../images/nature1.jpg';
import Nature2 from '../images/nature2.jpg';
import NatureIconEuronics from '../images/nature-yellow.png';
import NatureIconDatart from '../images/nature-orange.png';

import Sport1 from '../images/sport1.jpg';
import Sport2 from '../images/sport2.jpg';
import SportIconEuronics from '../images/sport-yellow.png';
import SportIconDatart from '../images/sport-orange.png';

import Dvbt from '../images/dvbt.jpg';
import DvbtIconEuronics from '../images/dvbt-yellow.png';
import DvbtIconDatart from '../images/dvbt-orange.png';

import Sale from '../images/sale.jpg';
import SaleIconEuronics from '../images/sale-yellow.png';
import SaleIconDatart from '../images/sale-orange.png';

import LogoEuronics from '../header/euronics.png';
import LogoDatart from '../header/datart.png';

import PlayButtonEuronics from '../images/play-button-yellow.png';
import PlayButtonDatart from '../images/play-button-orange.png';

// Other
import 'polyfill';
import 'main.less';
import config from '../config.json';
import Vue from 'vue';
import VueRouter from 'vue-router';

import HomeRoot from 'home/home-root';
import AppRoot from './app-root.html';
import HeaderRoot from '../header/header-root';
import Fullscreen from '../fullscreen/fullscreen';
import URI from 'urijs';

Vue.config.productionTip = false;
Vue.use(VueRouter);

// eslint-disable-next-line no-new
new Vue({
	el: '#app',
	components: {HeaderRoot},
	router: new VueRouter({
		routes: [
			{
				path: '/',
				component: HomeRoot
			},
			{
				path: '/fullscreen/:url(.+)',
				component: Fullscreen
			}
		]
	}),
	template: AppRoot,
	created () {
		this.config = config;
		this.params = this.parseUrl();
		this.images = this.getImages();
	},
	methods: {
		parseUrl () {
			const queryString = location.hash.slice(1);
			const url = new URI(`${queryString}`);
			return url.query(true);
		},
		getImages () {
			let images = {
				Sport1,
				Sport2,
				Movie1,
				Movie2,
				Nature1,
				Nature2,
				Dvbt,
				Sale
			};
			if (this.params.logo === 'euronics') {
				images = Object.assign({
					SaleIcon: SaleIconEuronics,
					MovieIcon: MovieIconEuronics,
					DvbtIcon: DvbtIconEuronics,
					NatureIcon: NatureIconEuronics,
					SportIcon: SportIconEuronics,
					Logo: LogoEuronics,
					PlayButton: PlayButtonEuronics
				}, images);
			} else {
				images = Object.assign({
					SaleIcon: SaleIconDatart,
					MovieIcon: MovieIconDatart,
					DvbtIcon: DvbtIconDatart,
					NatureIcon: NatureIconDatart,
					SportIcon: SportIconDatart,
					Logo: LogoDatart,
					PlayButton: PlayButtonDatart
				}, images);
			}
			return images;
		}
	}
});



// WEBPACK FOOTER //
// ./src/app/app-root.js